import { Component, input, output } from '@angular/core';

@Component({
  selector: 'cmi-button',
  imports: [],
  templateUrl: './button.html'
})
export class Button {
  public readonly label = input.required<string>();
  public readonly loadingLabel = input<string>();
  public readonly loading = input<boolean>(false);
  public readonly disabled = input<boolean>(false);
  /** For a button that owns its row, such as the primary action of a task pane. */
  public readonly fullWidth = input<boolean>(false);
  public readonly clicked = output<void>();
}
